export const Estadistica = () => {
    return(
        <>
            <p>estadistica</p>
        </>
    )
}